import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { getHistorialVivienda } from "../api/bacSarampionAPI.js";

const ESTADO_DOT = {
  Efectiva:     "#2d6a4f",
  Cerrada:      "#b7791f",
  Renuente:     "#b3261e",
  "No habitada": "#8b95a1",
};

export default function HistorialViviendaModal({ show, onClose, codigoVivienda }) {
  const [historial, setHistorial] = useState([]);
  const [cargando,  setCargando]  = useState(false);

  useEffect(() => {
    if (!show || !codigoVivienda) return;
    setCargando(true);
    getHistorialVivienda(codigoVivienda)
      .then(res => setHistorial(res.data || []))
      .catch(() => setHistorial([]))
      .finally(() => setCargando(false));
  }, [show, codigoVivienda]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem" }}>
          Historial de vivienda
          <div style={{ fontFamily: "monospace", fontSize: 12, color: "#6c757d", fontWeight: 400 }}>{codigoVivienda}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {cargando && <p className="text-muted">Cargando...</p>}
        {!cargando && !historial.length && <p className="text-muted">Sin intentos registrados.</p>}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {historial.map((v) => (
            <div key={v.id} style={{ border: "1px solid #e9ecef", borderRadius: 10, padding: "10px 14px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontWeight: 700, fontSize: 13 }}>Intento #{v.numero_visita}</span>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12.5, fontWeight: 600 }}>
                  <span style={{ width: 8, height: 8, borderRadius: "50%", background: ESTADO_DOT[v.estado_vivienda] }} />
                  {v.estado_vivienda}
                </span>
              </div>
              <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                📅 {v.createdAt?.split("T")[0]} · 👤 {v.entrevistador}
              </div>
              {v.estado_vivienda === "No efectiva" && v.motivo_no_efectiva && (
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 2 }}>
                  Motivo: {v.motivo_no_efectiva}
                </div>
              )}
              {v.nota_revisita && (
                <div style={{ fontSize: 12, color: "#b7791f", marginTop: 4, fontStyle: "italic" }}>
                  "{v.nota_revisita}" {v.fecha_revisita_sugerida && `— sugerida para ${v.fecha_revisita_sugerida}`}
                </div>
              )}
              {v.estado_vivienda === "Efectiva" && (
                <div style={{ fontSize: 12, color: "#374151", marginTop: 4 }}>
                  {v.numero_personas_vivienda} persona(s) · EISP: {v.eisp_encontrado || "—"}
                </div>
              )}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
}